import { TMaintenancePackageInitialState } from '../types';

export const DEFAULT_MAINTENANCE_PACKAGE_STATE: TMaintenancePackageInitialState =
    {
        maintenancePackages: null,
        maintenancePackage: null,
        total: 0,
        loading: false,
        error: null,
        success: null,
    };
